import React, { lazy } from 'react';
import './InstagramStories.sass';
import i18n from '../../../../../i18n';
import instagramLogo from './../../../../../resources/images/instagramStory/instagram.png';
import instagramStory from './../../../../../resources/images/instagramStory/instagramStory.jpeg';
import Config from '../../../../../base/config/Config';
const Button = lazy(() => import('./../../../../component/button/Button'));
const Title = lazy(() => import('../../../../component/title/Title'));
const Message = lazy(() => import('./../../../../component/message/Message'));

function InstagramStories() {

    var boxArray = [
        {
            title: i18n.t('Auto-post Instagram Stories'),
            message: i18n.t('Effortlessly amplify your brand\'s presence with our auto-post feature. Customize your stories with gifs, text, emojis, and more. Schedule ahead and ensure timely content delivery on Instagram, reaching and engaging your target audience effectively.'),
            type: 'Primary'
        },
        {
            title: i18n.t('Extended video time for stories'),
            message: i18n.t('Unleash your storytelling potential with extended video time. Make use of up to 60 seconds to captivate your audience with compelling visuals, detailed product showcases, and impactful narratives. Take your content to new heights and create memorable videos.'),
            type: 'Secondary'
        }];
    return (
        <div className="InstagramStoriesArea">
            <div className='InstagramTopArea'>
                <img className='InstagramLogo' src={instagramLogo} />
                <Title size="Big" type="Primary" text={i18n.t('Creating Stories just got a lot easier').toUpperCase()} />
                <Button to={`${Config.appHost}register?utm_source=website&utm_medium=homepage&utm_campaign=cta-6`} size="Medium" type="Tertiary" text={i18n.t('Try it Today')} />
            </div>
            <div className='InstagramBottomArea'>
                <div className='InstagramBottomLeftArea'>
                    <img className='InstagramStoriesImage' src={instagramStory} />
                </div>
                <div className='InstagramBottomRightArea'>
                    <div className="InstagramStoriesBoxArea">
                        {boxArray.map((item) => {
                            return <div className={'InstagramStoriesBox ' + item.type}>
                                <div className="InstagramStoriesLabel">{i18n.t('New on Swonkie').toUpperCase()}</div>
                                <Title size="Medium" type="Secundary" text={item.title.toUpperCase()} />
                            </div>;
                        })}
                    </div>
                    <Button to={`${Config.appHost}register?utm_source=website&utm_medium=homepage&utm_campaign=cta-7`} size="Medium" type="Tertiary" text={i18n.t('Try it Today')} />
                </div>
            </div>
        </div>
    );
}

export default InstagramStories;
